import { applyMiddleware, compose, createStore } from 'redux';
import { createMigrate, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web and AsyncStorage for react-native
import ReduxThunk from 'redux-thunk';

import reducers from 'reducers';

import migrations from './migrations';

/**
 * When updating the version, please move the old version of the migration to a vNum file in the
 * pastMigrations folder. Be sure to add it to the export in the index.js file in that folder
 * as well.
 */
const persistConfig = {
  key: 'root',
  version: 5,
  storage,
  // these reducers and all its states will be persisted and synced with localStorage
  whitelist: ['addressAutocomplete'],
  migrate: createMigrate(migrations, { debug: false }),
};

const persistedReducer = persistReducer(persistConfig, reducers);

const composeEnhancers =
  (window.Chime.config.ENVIRONMENT !== 'production' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

export const persistedStore = createStore(
  persistedReducer /* default state */,
  composeEnhancers(applyMiddleware(ReduxThunk))
);
export const persistor = persistStore(persistedStore);
